import { AxiosRequestConfig } from "axios";
import { ProductCreateRequest } from "src/interfaces/bold/product/product";
import { createOrUpdateSupplierProduct, createProduct, updateProduct } from "../apiRequests";
import { cleanText } from "./mappings";

const mapProductFormValuesToProduct = (values): ProductCreateRequest => {

  //  console.log("Values", values, values.ProductLine)
  let product: any = {
    Name: cleanText(values.Name),
    ...(values.ValidFrom != null && { ValidFrom: new Date(values.ValidFrom) }),
    ...(values.ValidTo != null && { ValidTo: new Date(values.ValidTo) }),
    Status: values.Status,
    ProductTypesId: values.ProductType,
    ProductClassId: values.ProductClass,
    ...((values.ProductSubClass == "null" || !values.ProductSubClass) ? null : { ProductSubClassId: values.ProductSubClass?.hasOwnProperty('Key') ? null : values.ProductSubClass }),
    //IsPhysical: values.IsPhysical,
    //IsDigital: values.IsDigital,
    ProductDefinitionId: values.ProductDefinition,
    ManufacturerPartnerId: values.Manufacturer,
    ManufacturerProductId: cleanText(values.ManufacturerProductId),
    ManufacturerAltProductId: cleanText(values.ManufacturerAltProductId),
    ManufacturerProductName: cleanText(values.ManufacturerProductName),
    NumberOfIncludedItems: values.NumberOfIncludedItems == "" ? 1 : parseInt(values.NumberOfIncludedItems),


    IsCustomerSpecific: values.IsCustomerSpecific,

    ProductLineId: values.ProductLine == "null" || values.ProductLine == "" ? null : (values.ProductLine?.hasOwnProperty('Key') ? null : values.ProductLine),
    //only send if its a number
    CountryOfOriginId: (values.CountryOfOrigin == "" || values.CountryOfOrigin == "null") ? null : (values.CountryOfOrigin?.hasOwnProperty('Key') ? null : values.CountryOfOrigin),


    TARIC: parseInt(values.TARIC ?? null),
  }
  return product;
}

const toSupplierProductLinkPayload = (values) => {

  return {
    ProductId: values.ProductId,
  };
}

export const supplierProductLinkPatchRequest = ({ values, changedSupplierProducts }): AxiosRequestConfig[] => {
  const linkToCurrentProductPayload = toSupplierProductLinkPayload(values);
  const existingIds = values.SupplierProducts.map(p => p.SupplierAssortmentItemId);
  const requests = [];
  changedSupplierProducts.forEach(product => {
    if (!existingIds.includes(product.SupplierAssortmentItemId)) {
      requests.push(createOrUpdateSupplierProduct(linkToCurrentProductPayload, "PATCH", product.SupplierAssortmentItemId));
    }
  });
  return requests;
};



export const productPostRequest = (values): AxiosRequestConfig<ProductCreateRequest> => {
  let product = mapProductFormValuesToProduct(values);

  const request = createProduct(product);
  return request;
};

export const productPutRequest = (values): AxiosRequestConfig<ProductCreateRequest> => {
  const product = mapProductFormValuesToProduct(values);
  //console.log("Product Put Request", product)
  const request = updateProduct(values.ProductId, product);
  return request;
};

